import { useLayerStore } from '../store/useLayerStore';
import { ILayerService } from './ILayerService';
import { LayerServiceImpl } from './LayerServiceImpl';
import { LayerServiceExceptionDecorator } from './LayerServiceExceptionDecorator';
import { LayerServiceLogDecorator } from './LayerServiceLogDecorator';

export class LayerServiceFactory {
  private static instance: LayerServiceFactory | null = null;
  private layerStore: typeof useLayerStore;

  public static initialize(layerStore: typeof useLayerStore) {
    LayerServiceFactory.instance = new LayerServiceFactory(layerStore);
  }

  public static getInstance() {
    if (LayerServiceFactory.instance === null) {
      throw new Error(
        'LayerServiceFactory not yet initialized. Call LayerServiceFactory.initialize() first.',
      );
    }
    return LayerServiceFactory.instance;
  }

  private constructor(layerStore: typeof useLayerStore) {
    this.layerStore = layerStore;
  }

  public createLayerService(): ILayerService {
    let result: ILayerService = this.makeLayerService();

    result = new LayerServiceExceptionDecorator(result);
    result = new LayerServiceLogDecorator(result);

    return result;
  }

  private makeLayerService(): ILayerService {
    return new LayerServiceImpl(this.layerStore);
  }
}
